import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalComponent } from './modal.component';
export class ModalModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  exports: [ModalComponent],
  declarations: [ModalComponent],
  providers: [],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalModule_tsickle_Closure_declarations() {
/** @type {?} */
ModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
